import React, { Component } from 'react';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
//import logo from './logo.svg';
import './assets/css/App.css'; 

import { CATEGORIES, LOCATION } from './utils/Constants';
import Client from './utils/Client';
import HandleData from './utils/HandleData';
import Header from './components/sections/Header';
import Footer from './components/sections/Footer';
import Home from './components/pages/Home';
import Listing from './components/pages/Listing';
import BusinessDetail from './components/pages/BusinessDetail';
import BusinessDetailPriority from './components/pages/BusinessDetailPriority';
import GetFound from './components/pages/GetFound';
import SiteMap from './components/pages/SiteMap';
import SearchResults from './components/pages/SearchResults';

localStorage.clear();

class App extends Component {
  state = {
    list: [],
    priorityList: [],
    tweets: [],
    events: [],
    loadingList: false,
    type: '',
    typeName: '',
    typeDir: '',
    keyword: '',
    searchCount: 0
  }
  
  componentDidMount(){
    Client.triggerTracking();
    this.getTweets();
    this.getEvents();
  }
  getEvents = () => {
    Client.getEventsEventbrite(this.setEvents);
  }
  setEvents = (data) => {
    //var sortedData = HandleData.sortData(data, 'start.local');
    this.setState({
      //events: sortedData
      events: data
    });
  }
  getTweets = () => {
    Client.getTweets(this.setTweets);
  }
  setTweets = (data) => {
    this.setState({
      tweets: data
    });
  }
  search = (keyword) => {
    Client.search(keyword, this.searchResults);
    this.setState({
      loadingList: true,
      list: [],
      keyword: keyword,
      searchCount: 0
    });
    
  }

  searchResults = (data, keyword) => {
    this.getSearchCount(data);
    
    
  }
  getSearchCount = (data) => {
    var count = 0;
    data.forEach((value, idx)=> {
      
      if(value.vicinity.indexOf(LOCATION) > -1){
        count += 1;
      }
    })
    this.setState({
      list: data,
      loadingList: false,
      searchCount: count
    });
  }
  getPriorityList = (type) => {
    Client.getPriorityList(type, this.setPriorityList);
  }
  setPriorityList = (data) => {
    this.setState({
      priorityList: data
    });
  }
  getList = (val) => {
    
    Client.getList(val, this.setList);
    this.setState({
      loadingList: true,
      list: []
    })
  }
  setList = (data, val) => {
    var sortedData = HandleData.sortData(data, 'name');
    localStorage.setItem(val.type, JSON.stringify(sortedData));
    this.setState({
      list: sortedData,
      loadingList: false,
      type: val.type,
      typeName: val.name,
      typeDir: val.dir
    })
  }
  getTypeFromDir = (dir, getList) => {
    CATEGORIES.forEach((val, idx) => {
      if(dir === val.dir) {
        if(getList) {
          this.checkLocalStorage(val);
        }
        else {
          this.setState({
            type: val.type,
            typeName: val.name,
            typeDir: val.dir
          });
        }
        
      }
    });
  }
  checkLocalStorage = (val) => {
    if(localStorage.getItem(val.type)) {
      let list = JSON.parse(localStorage.getItem(val.type));
      this.setState({
        list: list,
        loadingList: false,
        type: val.type,
        typeName: val.name,
        typeDir: val.dir
      });
    }
    else {
      this.getList(val);
    }
  }

  render() {
    
    return (
      <div className="page-wrapper">
        <div className="main-wrapper">
        <Header
          doSearch={this.search}
          list={this.state.list}
          loadingList={this.state.loadingList}
          searchPageActive={this.state.searchPageActive}
        />
        
        <div className="main-content homepage">
          <Switch>
            <Route exact path="/" render={(props) => (
              <Home {...props}
                events={this.state.events}
              />
            )}/>
            <Route path='/businesses/:dir' render={(props) => (
              <Listing {...props} 
                getTypeFromDir={this.getTypeFromDir}
                getPriorityList={this.getPriorityList}
                list={this.state.list}
                priorityList={this.state.priorityList}
                loadingList={this.state.loadingList}
                type={this.state.type}
                typeDir={this.state.typeDir}
                typeName={this.state.typeName}
                  />
            )}/>
            <Route path='/details/:dir/:id' render={(props) => (
              <BusinessDetail {...props} 
                
                getTypeFromDir={this.getTypeFromDir}
                type={this.state.type}
                typeDir={this.state.typeDir}
                typeName={this.state.typeName}
                  />
            )}/>
            <Route path="/pdetails/:id" component={BusinessDetailPriority}/>
            <Route path="/getfound" component={GetFound}/>
            <Route path="/sitemap" component={SiteMap}/>
            <Route path='/search/:keyword' render={(props) => (
              <SearchResults {...props} 
                keyword={this.state.keyword}
                doSearch={this.search}
                getPriorityList={this.getPriorityList}
                list={this.state.list}
                priorityList={this.state.priorityList}
                loadingList={this.state.loadingList}
                searchCount={this.state.searchCount}
                  />
            )}/>
            <Route path="*" render={() => <Redirect to="/" /> }/>
          </Switch>
        </div>
        
      </div>
      <div className="footer-wrapper">
        <Footer
          tweets={this.state.tweets}
        />
      </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js